import React from 'react';
import { Button } from 'react-bootstrap';
import { CloseIcon } from '../icons/CloseIcon.jsx';

const FilterWrapper = ({ children, action }) => {
  return (
    <div className="flex m-b-12">
      <div className="flex-1">{children}</div>
      <Button className="btn-cross m-l-8 m-t-20" onClick={action}>
        <CloseIcon />
      </Button>
    </div>
  );
};

export default FilterWrapper;
